import { render, staticRenderFns } from "./ExtendedViewPopUp.vue?vue&type=template&id=97b75c98&scoped=true&"
import script from "./ExtendedViewPopUp.vue?vue&type=script&lang=js&"
export * from "./ExtendedViewPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedViewPopUp.vue?vue&type=style&index=0&id=97b75c98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b75c98",
  null
  
)

export default component.exports